module.exports = __webpack_public_path__ + "img/071.06d2e5e9.png";